import { userListHeaderStyles } from "@insite/content-library/Widgets/UserList/UserListHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

userListHeaderStyles.titleGridItem = {
    width: [10, 10, 8, 9, 9],
};
userListHeaderStyles.buttonsGridItem = {
    css: css`
        justify-content: flex-end;
        button {
            // padding: 10px 34px;
            border-radius: 0;
            background: ${getColor("primary")};
            border: 2px solid ${getColor("primary")};
            span[class^="TypographyStyle"] {
                color: ${getColor("primary.contrast")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            &:hover {
                background: ${getColor("text.accent")};
                /* border: 2px solid  background: ${getColor("text.accent")}; */
                span[class^="TypographyStyle"] {
                    color: ${getColor("primary.contrast")};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        background: transparent;
                        border: none;
                        padding: 0 !important;
                        &:hover {
                            background: transparent;
                            border: none;
                        }
                    `,
                    css`
                        background: transparent;
                        border: none;
                        padding: 0 !important;
                        &:hover {
                            background: transparent;
                            border: none;
                        }
                    `,
                    null,
                    null,
                    null,
                ])};
        }
        ul > li > button {
            padding: 10px 15px !important;
            text-align: center;
        }
    `,
    width: [2, 2, 4, 3, 3],
};
userListHeaderStyles.searchContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle-sc"] {
                            flex-basis: 100%;
                            max-width: 100%;
                        }
                    }
                `,
                css`
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle-sc"] {
                            flex-basis: 100%;
                            max-width: 100%;
                        }
                    }
                `,
                css`
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle-sc"] {
                            flex-basis: 100%;
                            max-width: 100%;
                        }
                    }
                `,
                null,
                null,
            ])};
    `,
};
userListHeaderStyles.searchGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                null,
                null,
            ])};
    `,
};

userListHeaderStyles.searchForm = {
    css: css`
        display: flex;
        justify-content: space-between;
        width: 100%;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: flex;
                `,
                css`
                    display: flex;
                `,
                css`
                    display: flex;
                `,
                null,
                null,
            ])};
    `,
};

userListHeaderStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex: 1 1 auto;
            margin-right: 1rem;
        `,
        formInputWrapper: css`
            margin-top: 0px;
        `,
    },
    iconProps: {
        src: "Search",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        top: 5px;
                    `,
                    css`
                        top: 5px;
                    `,
                    css`
                        top: 5px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
};

userListHeaderStyles.searchSubmitButton = {
    variant:"secondary",
};
userListHeaderStyles.searchGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        div[class^="FormInputWrapper"] {
            input {
                height: 40px;
            }
            span[class^="IconWrapper"] {
                top: 3px;
            }
        }
    `,
};
